import { Link, LinkProps } from 'react-router-dom';
import { usePlatforms } from '@sandtech-hub-monorepo/ui-kit-site';

interface Props extends Omit<LinkProps, 'to'> {
  sdk: boolean;
  href: string;
}

export const HeaderLink = ({ sdk, href, ...otherProps }: Props) => {
  const { all } = usePlatforms(process.env['NX_COOKIE_DOMAIN'] || '');

  if (!sdk) {
    return <Link to={href} {...otherProps} />;
  }

  return (
    <a
      href={href.startsWith('/') ? all.ehub.origin + href : href}
      {...otherProps}
    />
  );
};
